/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconError8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconError8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path d="m3.584 2 .083 2.667h.667L4.417 2h-.833Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.334 4A3.333 3.333 0 1 1 .667 4a3.333 3.333 0 0 1 6.667 0Zm-.667 0a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0Z"
                fill="currentColor"
            />
            <path d="M4 6.167a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconError12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconError12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path d="M5.375 3 5.5 7h1l.125-4h-1.25Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0Zm-1 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
                fill="currentColor"
            />
            <path d="M6 9.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconError16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconError16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="m7.166 4 .167 5.334h1.333L8.833 4H7.166Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.666 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.333 0Zm-1.333 0A5.333 5.333 0 1 1 2.666 8a5.333 5.333 0 0 1 10.667 0Z"
                fill="currentColor"
            />
            <path d="M8 12.334a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconError20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconError20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path d="m8.959 5 .208 6.666h1.667L11.042 5H8.959Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.334 10a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Zm-1.667 0a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0Z"
                fill="currentColor"
            />
            <path d="M10 15.416a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconError24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconError24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="m10.75 6 .25 8h2l.25-8h-2.5Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
                fill="currentColor"
            />
            <path d="M12 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconError = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconError(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconError8 {...iconProps} />;
        case '12':
            return <IconError12 {...iconProps} />;
        case '16':
            return <IconError16 {...iconProps} />;
        case '20':
            return <IconError20 {...iconProps} />;
        case '24':
            return <IconError24 {...iconProps} />;
        default:
            return <IconError24 {...iconProps} />;
    }
});
